import { createContext } from "react";

export type CollapsibleCardContextProps = {
  expanded: boolean;
  toggleExpanded: () => void;
};

const CollapsibleCardContext = createContext<CollapsibleCardContextProps>({
  expanded: true,
  toggleExpanded: () => {},
});

export default CollapsibleCardContext;
